import * as R from 'ramda';
import angular from 'angular';

export default function BulkDeleteReportInstanceController(
  $q,
  $rootScope,
  $scope,

  alerts,
  confirmDialog,
  loaderService,
  ssDialogService,
  reportsDataService,
  userService,
) {
  const vm = this;

  vm.canExpand = true;

  vm.handleBulkDeleteChange = _handleBulkDeleteChange;
  
  _activate();

  function _activate() { 
    _initPermissions();
  }

  function _handleBulkDeleteChange() {
    $rootScope.$broadcast('selectBulkReportInstanceChange');
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('admin').then(permissions => {
      vm.permissions = permissions;
    });
  }
}

BulkDeleteReportInstanceController.$inject = [
  '$q',
  '$rootScope',
  '$scope',

  'alerts',
  'confirmDialog',
  'loaderService',
  'ssDialogService',
  'reportsDataService',
  'userService',
];
